// extracted by mini-css-extract-plugin
export default {"app":"app_app__82uWY","main":"app_main__aP8Uf","container":"app_container__2rN2c"};